export const pagesLegalWelfareAndTaxesEn = {
  pageTitle: 'Legal Welfare and Taxes',
  statutoryStandards: {
    columns: {
      description: 'Description',
      link: 'Link',
      name: 'Name'
    },
    empty: {
      description: 'No statutory standards match the current filters.'
    },
    error: {
      retry: 'Reload',
      title: 'Could not load statutory standards.'
    },
    fields: {
      description: {
        label: 'Description'
      },
      period: {
        label: 'Effective period'
      },
      sources: {
        label: 'Related sources'
      }
    },
    detail: {
      backToList: 'Statutory standards',
      sections: {
        basic: 'Basic information',
        table: 'Lookup table'
      }
    },
    filters: {
      searchPlaceholder: 'Search by name or description'
    },
    statusTabs: {
      active: 'Active',
      archived: 'Archived',
      scheduled: 'Scheduled'
    },
    period: {
      openEnded: '{{start}} –',
      range: '{{start}} – {{end}}'
    },
    table: {
      empty: {
        description: 'Statutory tables are distributed with the product, and resident tax comes from municipality notices.',
        title: 'No table.'
      }
    }
  },
  tabs: {
    statutoryStandards: 'Statutory standards'
  }
};